import { useGetApPayeeContactInformPdfTemplate } from '@/context/services/doc_instructions/DocInstructions.service';
import { InstructionPdfForm } from '@/features/ap_payees/components/DocInstructionMenu/types';
import { useTranslation } from '@/i18n';
import { isObjectEmpty } from '@/utils/isObjectEmpty';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';

export const useInstructionInformationHandler = () => {
  const { t } = useTranslation();
  const { data: templateData } = useGetApPayeeContactInformPdfTemplate();

  const [customTemplate, setCustomTemplate] = useState({});
  const [appliedCustomTemplate, setAppliedCustomTemplate] = useState(false);
  const methods = useFormContext<InstructionPdfForm>();
  const [tooltipVisible, setTooltipVisible] = useState(false);

  const hasCustomTemplate = useMemo(() => {
    return !isObjectEmpty(customTemplate);
  }, [customTemplate]);

  const { reset } = methods;

  useEffect(() => {
    if (isObjectEmpty(templateData.default_template)) return;
    reset(templateData.default_template);
  }, [reset, templateData.default_template]);

  useEffect(() => {
    if (isObjectEmpty(templateData.saved_template)) return;
    setCustomTemplate(templateData.saved_template || {});
  }, [templateData.saved_template]);

  const onApplyCustomTemplate = useCallback(() => {
    reset(customTemplate);
    setTooltipVisible(true);
    /** We changed the text applied success for 3 second then change to original text */
    setAppliedCustomTemplate(true);
    setTimeout(() => {
      setAppliedCustomTemplate(false);
      setTooltipVisible(false);
    }, 3000);
  }, [reset, customTemplate]);

  const templateTooltip = useMemo(() => {
    if (!hasCustomTemplate)
      return t('export_instruction_pdf_apply_template_tooltip');
    if (appliedCustomTemplate)
      return t('export_instruction_pdf_apply_template_success_tooltip');
    return '';
  }, [appliedCustomTemplate, hasCustomTemplate, t]);

  const applyTemplateButtonLabel = useMemo(() => {
    if (appliedCustomTemplate)
      return t('export_instruction_pdf_apply_template_success');
    return t('export_instruction_pdf_apply_template');
  }, [appliedCustomTemplate, t]);

  return {
    methods,
    hasCustomTemplate,
    onApplyCustomTemplate,
    templateTooltip,
    applyTemplateButtonLabel,
    appliedCustomTemplate,
    tooltipVisible,
  };
};
